<template>
  <div v-if="match!=null">
    <div class="match-wrap">
      <van-row>
        <van-col span="8">
          <div class="match-team hometeam">主</div>
          <div class="main">{{match.homeTeamName}}</div>
        </van-col>
        <van-col span="8">
          <div class="match-team">{{(match.status===1||match.status===2)?match.finalScore:""}}</div>
          <div class="main">{{match.cstatus}}</div>
        </van-col>
        <van-col span="8">
          <div class="match-team awayteam">客</div>
          <div class="main">{{match.awayTeamName}}</div>
        </van-col>
      </van-row>
    </div>
    <div class="title ">分析</div>
    <div v-if="match.projects.length>0" class="van-hairline--bottom van-hairline--top">
      <project-item :project="{
            articles:item.project.articles,
            project_id:item.project_id,
            is_multi:item.project.articles.length>1,
            avatar:item.project.articles[0].article.writer.avatar.web_path,
            category:item.project.project_category,
            title:item.project.project_title,
            content_visible:item.project.articles[0].article.article_content_visible,
            price:item.project.project_price,
            borwser_num:item.project.project_borwser_num,
            state:item.project.project_state
          }" v-for="(item, index) in  match.projects" :key="item.project_id">
      </project-item>
    </div>
    <div v-else class="van-hairline--bottom van-hairline--top no-project">
        暂无分析
    </div>
  </div>
</template>
<script>
    import ProjectItem from '@/views/components/ProjectItem'
    export default {
        name:"matchdetail",
        components:{
          ProjectItem
        },
        data() {
            return {
                match_id: this.$route.params.match_id,
                match:null,
            }
        },
        created(){
            this.getData(this.match_id)
        },
        mounted() {
        },

        methods:{
            getData: function (match_id) {
                let that = this;
                this.weapi.request({
                    url: 'projects_for_match',
                    method: 'get',
                    params: {'match_id':match_id},
                }).then(res => {
                    if (res.data.code === '200') {
                        that.match = res.data.data;
                        if(that.match.status === 1 || that.match.status === 2){
                            that.weutil.setWechatTitle("战报");
                        }
                        else if(that.match.status === 0){
                            that.weutil.setWechatTitle("前瞻");
                        }
                        else{
                            that.weutil.setWechatTitle("比赛详情");
                        }
                    }
                    else {
                    }
                }).catch(function (error) {
                    that.$toast('系统错误，请稍后重试！');
                }).finally(function (response) {
                })
            },
            go_detail: function (ID) {
                this.$router.push({ name: this.werouter.project.name, params: { project_id: ID } })
            }
        }
    }

</script>
<style>
  .match-wrap{
    color: #fff;
    text-align: center;
    height: 120px;
    background-color: #1aad19;
  }
  .match-wrap .van-col{
    height:  120px;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .match-team{
    /*width: 24px;*/
    /*height: 24px;*/
    /*padding: 10px;*/
    font-size: 18px;
  }
  .match-team.hometeam{
    /*background-color: #ee0a24;*/
  }
  .match-team.awayteam{
    /*background-color: #1aad19;*/
  }
  .match-wrap .main{
    padding: 5px;
    font-size: 12px;
  }
  .title{
    text-align: center;
    font-weight: 600;
    color: #333;
    font-size: 16px;
    padding: 15px 10px 10px 10px;
  }
  .no-project{
    font-size: 18px;
    color: #888;
    text-align: center;
    padding: 30px;
  }


  .article-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    position: relative;
  }
  .article-content-wrap{
    margin-left: 10px;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    align-items: flex-start;
  }
  .article-wrap .game-over{
    position: absolute;
    right: 10px;
  }
  .tongji-wrap{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: center;
    font-size: 14px;
    margin-right: 20px;
  }
  .tongji-wrap span{
    margin-left: 5px;
  }
  /*.van-list{*/
    /*margin:10px;*/
    /*border-radius: 4px;*/
  /*}*/
</style>
